<header class="relative z-50">
  <div #subAnimate class="bg-white p-3 min-h-[4.5rem] flex items-center justify-between border-b border-[var(--gray10)]"
    [class.animate]="animate">
    <img src="/img/MoneyUp_V2.svg" alt="MoneyUp" class="w-full max-w-[7.1875rem] ml-3 cursor-pointer" (click)="home()">
    <button type="button" class="logout" (click)="logOut()">
      <fa-icon [icon]="faRightFromBracket" class="text-lg"></fa-icon>
      <span>Log out</span>
    </button>
  </div>
</header>
<main #main class="w-full overflow-auto"
  [ngClass]="isSafari() ? 'min-h-[calc(100vh-4.5rem)] max-h-[calc(100vh-4.5rem)]' : 'min-h-[calc(100dvh-4.5rem)] max-h-[calc(100dvh-4.5rem)]'">
  <router-outlet />
</main>